export const meta = {
  id: 'M05',
  slug: 'utilizar-plano',
  title: 'Como utilizar o Plano do Mentorado',
  description: 'Use o Plano para verificar foco, prioridades, metas e coerência entre objetivo e ações do mentorado.',
  profile: 'mentor',
  category: 'plano',
  type: 'task',
  status: 'published',
  order: 260,
  keywords: ['plano', 'mentorado', 'objetivo', 'competências', 'metas', 'ações', 'jornada'],
  previous: 'M04',
  next: 'M06',
  related: ['A04', 'M04', 'M06'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como utilizar o Plano do Mentorado

O Plano organiza o que o mentorado pretende fazer para avançar no próprio desenvolvimento.

A lógica principal é:

**Objetivo → Competência → Meta → Ação → Jornada.**

## O que observar

- clareza do objetivo;
- competências priorizadas;
- metas relacionadas;
- ações definidas;
- coerência com a Jornada e com as Formações;
- progresso e dificuldades de execução.

## Como usar na Mentoria

<Steps>
  <Step title="Relembre o objetivo">
    Verifique se o Plano continua orientado para o resultado de desenvolvimento desejado.
  </Step>
  <Step title="Observe metas e ações">
    Identifique se as ações estão específicas o suficiente para gerar movimento real.
  </Step>
  <Step title="Conecte execução e aprendizagem">
    Relacione o Plano à Jornada, às Formações, às Evidências e aos Acordos definidos em Mentoria.
  </Step>
</Steps>

<Callout type="tip">
  Use o Plano para manter foco e continuidade. Ele deve ajudar a transformar reflexão em ação, não virar apenas uma lista de intenções.
</Callout>

<HelpImage alt="Plano do mentorado na visão do Mentor" pendingId="M05.1" />
